import { Injectable } from '@angular/core';

@Injectable()
export class HelpersService {

  constructor() { }

  public calculateTimeSpan(timeFrom: string, timeTo: string): number {
    let timeSpan = 0;

    if (timeFrom && timeTo) {
      if (timeFrom.indexOf(':') > -1 && timeTo.indexOf(':') > -1) {
        const hourFrom: number = Number(timeFrom.substring(0, 2));
        const minuteFrom: number = Number(timeFrom.substring(3, 5));
        const hourTo: number = Number(timeTo.substring(0, 2));
        const minuteTo: number = Number(timeTo.substring(3, 5));

        timeSpan = this.calculateTimeSpanFromNumbers(hourFrom, minuteFrom, hourTo, minuteTo);
      }
    }

    return timeSpan;
  }

  public calculateTimeSpanFromNumbers(hourFrom: number, minuteFrom: number, hourTo: number, minuteTo: number): number {
    let timeSpan = 0;
    timeSpan = hourTo - hourFrom;
    timeSpan = timeSpan + ((minuteTo - minuteFrom) / 60);

    return Math.round(timeSpan * 100) / 100;
  }

  public getHour(time: string): number {
    let hour = 0;
    if (time.indexOf(':') > -1) {
      hour = Number(time.substring(0, 2));
    }
    return hour;
  }

  public getMinute(time: string): number {
    let hour = 0;
    if (time.indexOf(':') > -1) {
      hour = Number(time.substring(3, 5));
    }
    return hour;
  }

  /**
   * Creates a list with periodes (+/- X months) according to the given key date.
   * A periode is a numeric combination of year + date (e.g. 201712 -> December 2017).
   * @param keyDate
   * @param numberOfMonthBack
   * @param numberOfMonthinFuture
   */
  public getListOfPeriodes(keyDate: Date, numberOfMonthBack: number, numberOfMonthinFuture: number) {
    const listOfPeriods = [];

    for (let i = -numberOfMonthBack; i <= numberOfMonthinFuture; i++) {
      const periodDate = new Date(keyDate);
      periodDate.setMonth(keyDate.getMonth() + i);

      if (periodDate.getMonth() < 9) {
        // for month with one digits (e.g. April -> "4"), insert a leading zero
        listOfPeriods.push(periodDate.getFullYear().toString() + '0' + (periodDate.getMonth() + 1).toString());
      } else {
        // for month with two digits (e.g. October -> "10")
        listOfPeriods.push(periodDate.getFullYear().toString() + (periodDate.getMonth() + 1).toString());
      }
    }

    return listOfPeriods;
  }

  public getPeriodeFilterString(fieldName: string, filterPeriode: string): string {
    if (filterPeriode && filterPeriode.length === 6) {
      const year = filterPeriode.substr(0, 4);
      const month = filterPeriode.substr(4, 2);

      // get the from and to dates in the format "YYYY-MM-DD"
      const dateFrom = year + '-' + month + '-01';
      const dateTo = (new Date(Date.UTC(+year, (+month), 1))).toISOString().substr(0, 10);

      return fieldName + '>=D"' + dateFrom + '",' + fieldName + '<D"' + dateTo + '",';
    }

    return '';
  }
}



// WEBPACK FOOTER //
// C:/.NET Projects/Angular Apps/TimeManagement/src/app/services/helpers.service.ts